// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2ZNH-","label":"SetPasswdForm_label__2Gmlq"};